import { render, staticRenderFns } from "./DistributeBalanceUnallocated.vue?vue&type=template&id=2068959e&scoped=true&"
import script from "./DistributeBalanceUnallocated.vue?vue&type=script&lang=ts&"
export * from "./DistributeBalanceUnallocated.vue?vue&type=script&lang=ts&"
import style0 from "./DistributeBalanceUnallocated.vue?vue&type=style&index=0&id=2068959e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2068959e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VDialog,VDivider,VIcon,VImg,VRow,VTextField})
